module.exports = {"questionURL":"Read.php","saveURL":"Read.php","scoreIncrement":50,"comboBonus":50,"instructionText":"Your car is racing against another car.\nYou can make your car go faster by answering questions correctly.\nRead the questions carefully and click the icon for the right answer.\nYou will score 50 points for each correct answer."}


//////////////////
// WEBPACK FOOTER
// ./src/js/conf.json
// module id = 218
// module chunks = 0